import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const PHRASES = ['Loading reels', 'Calibrating frames', 'Lighting set', 'Ready'];

export default function Preloader({ onDone }) {
  const [progress, setProgress] = useState(0);
  const [phraseIdx, setPhraseIdx] = useState(0);
  const [done, setDone] = useState(false);

  useEffect(() => {
    const start = performance.now();
    const DURATION = 1600;
    let raf;
    let finished = false;
    const complete = () => {
      if (finished) return;
      finished = true;
      setProgress(1);
      setPhraseIdx(PHRASES.length - 1);
      setDone(true);
      onDone?.();
    };
    const tick = (t) => {
      const p = Math.min(1, (t - start) / DURATION);
      setProgress(p);
      setPhraseIdx(Math.min(PHRASES.length - 1, Math.floor(p * PHRASES.length)));
      if (p < 1) raf = requestAnimationFrame(tick);
      else setTimeout(complete, 400);
    };
    raf = requestAnimationFrame(tick);
    // Guaranteed completion even if rAF is suspended (e.g. background tab)
    const fallback = setTimeout(complete, DURATION + 1200);
    return () => {
      cancelAnimationFrame(raf);
      clearTimeout(fallback);
    };
  }, [onDone]);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ y: '-100%' }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
          className="fixed inset-0 z-[100] bg-[#050505] flex flex-col items-center justify-center"
        >
          <motion.p
            className="font-display font-black text-white tracking-tighter mb-8"
            style={{ fontSize: 'clamp(56px, 14vw, 200px)', lineHeight: 0.85 }}
            initial={{ y: 40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.7 }}
          >
            UTMEDIA
          </motion.p>
          <div className="w-64 md:w-96 h-px bg-white/10 relative overflow-hidden">
            <motion.div
              style={{ width: `${progress * 100}%` }}
              className="absolute inset-y-0 left-0 bg-white"
            />
          </div>
          <p className="mt-4 text-[10px] uppercase tracking-[0.3em] text-white/50">
            {PHRASES[phraseIdx]} · {Math.floor(progress * 100)}%
          </p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
